<template>
  <!-- Contenedor -->
  <v-row justify="center">
    <v-col cols="12">
      <!-- Botón para registrar ingreso -->
      <PrimaryButton @click="dialog = true">
        Agregar empleado
      </PrimaryButton>
    </v-col>
    <!-- Diálogo -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <!-- Tarjeta si no está cargando -->
      <v-card v-if="!isLoading">
        <!-- Título -->
        <v-card-title>
          <p class="headline font-weight-bold mb-0">Registra un empleado</p>
        </v-card-title>
        <!-- Formulario -->
        <v-card-text class="mb-0 pb-0">
          <!-- Formulario -->
          <v-container fluid class="pa-0">
            <p class="subtitle-2 text-hint mb-1 mt-2">PERFIL</p>
            <v-row no-gutters>
              <!-- Nombre -->
              <v-flex xs12>
                <TextField
                  class="mb-3"
                  placeholder="Nombre y apellidos"
                  type="text"
                  name="name"
                  v-model="userName"
                />
              </v-flex>
              <!-- Email -->
              <v-flex xs12>
                <TextField
                  class="mb-3"
                  placeholder="Email"
                  v-model="email"
                  type="email"
                  name="username"
                />
              </v-flex>
              <!-- Contraseña -->
              <v-flex xs12>
                <TextField
                  class="mb-3"
                  placeholder="Contraseña"
                  v-model="password"
                  type="password"
                  name="password"
                />
              </v-flex>

              <!-- Confirmar contraseña -->
              <v-flex xs12>
                <TextField
                  class="mb-3"
                  placeholder="Confirma la contraseña"
                  v-model="confirmPassword"
                  type="password"
                  name="password"
                />
              </v-flex>
              <!-- Número de teléfono -->
              <v-flex xs12>
                <vue-tel-input
                  class="full-width mb-3"
                  v-model="userPhoneNumber"
                  inputId="userPhoneNumber"
                  enabledCountryCode
                  required
                  validCharactersOnly
                  @input="userPhoneNumberInput"
                  placeholder="Ingresa tu número de teléfono"
                ></vue-tel-input>
              </v-flex>
              <v-flex xs12>
                <p class="subtitle-2 text-hint mb-2 mt-2">
                  SUCURSALES
                </p>
                <v-select
                  v-model="selectedBranches"
                  :items="allBranches"
                  chips
                  label="Agregar sucursales"
                  multiple
                  filled
                  rounded
                  dense
                  no-data-text="No hay sucursales disponibles"
                  item-text="name"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <p class="subtitle-2 text-hint mb-2 mt-2">
                  ACCESOS
                </p>
                <v-select
                  v-model="selectedTabs"
                  :items="getMenuItems"
                  chips
                  label="Agregar pestañas"
                  multiple
                  filled
                  rounded
                  dense
                  no-data-text="No hay pestañas disponibles"
                  item-text="title"
                  item-value="key"
                ></v-select>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- Acciones -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Botón de cancelar -->
          <v-btn color="primary" text @click="reset">
            Cancelar
          </v-btn>
          <!-- Botón para guardar -->
          <v-btn color="primary" text @click="createUser">Guardar</v-btn>
        </v-card-actions>
      </v-card>
      <!-- Tarjeta si está cargando -->
      <v-card v-else align="center" justify="center">
        <v-progress-circular class="mt-12 mb-4" indeterminate color="primary" />
        <v-card-text class="text-center pb-12">
          Estamos registrando al empleado
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// Importar dependencias
import { VueTelInput } from "vue-tel-input";
import { mapGetters } from "vuex";

// Importar servicios
import UsersServices from "@/services/UsersServices";
import BranchesServices from "@/services/BranchesServices";

// Importar componentes
import PrimaryButton from "@/components/PrimaryButton";
import TextField from "@/components/TextField";

export default {
  name: "create-user",
  components: {
    PrimaryButton,
    VueTelInput,
    TextField
  },
  data() {
    return {
      dialog: false,
      isLoading: false,
      userName: "",
      email: "",
      password: "",
      confirmPassword: "",
      userPhoneNumber: "",
      isUserPhoneNumberValid: false,
      newEmployee: {},
      allBranches: [],
      selectedBranches: [],
      selectedTabs: ["sales", "customers", "settings"]
    };
  },
  mounted: async function() {
    try {
      // Obtener sucursales
      this.allBranches = await BranchesServices.getBranchesInUserProfile();

      // Si hay una sola sucursal, seleccionarla
      if (this.allBranches.length === 1) {
        this.selectedBranches = [this.allBranches[0]._id];
      }
    } catch (err) {
      // Emitir evento con el error
      this.$emit("employee-error", err.message);
    }
  },
  methods: {
    createUser: async function() {
      // Verificar que los campos estén completos
      if (!this.areFieldsComplete) {
        this.$emit("employee-error", "Por favor rellena todos los campos");
        return;
      }

      // Verificar que el email sea válido
      if (!this.isEmailValid) {
        this.$emit("employee-error", "El correo no es válido");
        return;
      }

      // Verificar que el número de teléfono sea válido
      if (this.userPhoneNumber?.length > 0 && !this.isUserPhoneNumberValid) {
        this.$emit("employee-error", "El número de teléfono no es válido");
        return;
      }

      // Verificar que la contraseña pase la regla
      if (!this.isPasswordValid) {
        this.$emit(
          "employee-error",
          "La contraseña debe tener al menos 8 caracteres"
        );
        return;
      }

      // Verificar que las contraseñas sean igales
      if (!this.arePasswordsEqual) {
        this.$emit("employee-error", "Las contraseñas no coinciden");
        return;
      }

      // Crear objeto con datos del usuario
      const user = {
        name: this.userName,
        email: this.email.toLowerCase(),
        password: this.password,
        phone_number: this.userPhoneNumber,
        bussines_id: this.getProfile.bussines_id,
        is_active: true,
        tabs: this.selectedTabs
      };

      // Guardar el usuario en la base de datos
      try {
        this.isLoading = true;
        this.newEmployee = await UsersServices.createUser(user);

        // Verificamos si lo agregaron a alguna sucursal
        if (this.selectedBranches.length > 0) {
          // De ser así, las agregamos
          await this.addUserBranches();
        }

        // Enviar evento a mixpanel
        this.$mixpanel.track("new-employee", {
          distinct_id: this.getProfile.business_id
        });

        // Vaciar campos
        this.reset();
        this.$emit("new-user");
      } catch (err) {
        this.isLoading = false;
        // Emitir evento con el error
        this.$emit("employee-error", err.message);
      }
    },
    addUserBranches: async function() {
      // Agregamos a la sucursal
      await BranchesServices.addEmployeeToBranches(
        this.newEmployee._id,
        this.selectedBranches
      );
    },
    reset: function() {
      // Vaciamos los campos
      this.userName = "";
      this.email = "";
      this.password = "";
      this.confirmPassword = "";
      this.userPhoneNumber = "";
      this.newEmployee = {};
      this.isUserPhoneNumberValid = false;
      this.selectedBranches = [];
      this.selectedTabs = [
        "dashboard",
        "sales",
        "incomes",
        "losses",
        "settings"
      ];

      // Cerramos el dialogo
      this.dialog = false;
      // Dejamos de mostrar el spinner
      this.isLoading = false;
    },
    userPhoneNumberInput: function(name, data) {
      this.isUserPhoneNumberValid = data.isValid;
    }
  },
  computed: {
    ...mapGetters(["getProfile", "getMenuItems"]),
    areFieldsComplete: function() {
      return (
        !!this.userName &&
        !!this.email &&
        !!this.password &&
        !!this.confirmPassword
      );
    },
    isEmailValid: function() {
      // eslint-disable-next-line no-useless-escape
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.email);
    },
    isPasswordValid: function() {
      return this.password.length > 7;
    },
    arePasswordsEqual: function() {
      return this.password === this.confirmPassword;
    }
  }
};
</script>

<style scoped></style>
